{
  "web3Wallet": "Exalt Exchange Web3 Cüzdanı",
  "web3WalletSubtitle": "Güvenli MetaMask / Trust Wallet • BNB Smart Chain • EXALT Cüzdanı",
  "connectWallet": "Cüzdan Bağla",
  "connectWeb3Wallet": "Web3 Cüzdanı Bağla",
  "disconnect": "Bağlantıyı Kes",
  "walletNotFound": "Cüzdan bulunamadı.",
  "walletAppNotFound": "MetaMask / Trust Wallet bulunamadı.",
  "installWallet": "Lütfen MetaMask veya Trust Wallet yükleyin.",
  "walletConnected": "Cüzdan başarıyla bağlandı.",
  "walletDisconnected": "Cüzdan bağlantısı kesildi.",
  "walletConnectionFailed": "Cüzdan bağlantısı başarısız oldu.",
  "walletAddress": "Cüzdan Adresi",
  "walletAddressCopied": "Cüzdan adresi kopyalandı.",
  "refreshBalance": "Bakiyeyi Yenile",
  "totalAssets": "Toplam Varlıklar",
  "assets": "Varlıklar",
  "send": "Gönder",
  "receive": "Al",
  "swap": "Takas",
  "history": "Geçmiş",
  "allWeb3Coins": "Tüm Web3 Coinleri",
  "searchCoin": "Coin Ara...",
  "receiverAddress": "Alıcı Adresi",
  "enterAmount": "Miktar Girin",
  "sendNow": "Şimdi Gönder",
  "receiveCrypto": "Kripto Al",
  "copyAddressReceive": "Adresi Kopyala / Al",
  "swapTrade": "Takas / İşlem",
  "fromCoin": "Kaynak Coin",
  "toCoin": "Hedef Coin",
  "swapNow": "Şimdi Takas Et",
  "transactionHistory": "İşlem Geçmişi",
  "searchTransaction": "İşlem Ara...",
  "syncHistory": "Geçmişi Senkronize Et",
  "syncReceive": "Alımı Senkronize Et",
  "clearHistory": "Geçmişi Temizle",
  "clearHistoryConfirm": "Tüm işlem geçmişini temizlemek istediğinizden emin misiniz?",
  "noTransactionsYet": "Henüz işlem yok.",
  "bnbBalance": "BNB Bakiyesi",
  "insufficientBnbGas": "Yetersiz BNB. Gas ücretleri için en az 0.01 BNB bulundurun.",
  "transactionPending": "İşlem beklemede...",
  "transactionConfirmed": "İşlem onaylandı.",
  "bnbSentSuccessfully": "BNB başarıyla gönderildi.",
  "bnbSendFailed": "BNB gönderimi başarısız oldu.",
  "swapPending": "Takas beklemede...",
  "swapCompleted": "Takas tamamlandı.",
  "swapFailed": "Takas başarısız oldu.",
  "approvalPending": "Onay beklemede...",
  "tokenSwapRouteSoon": "Token-token takası BNB rotası üzerinden eklenecektir.",
  "receiveTransactionSynced": "Alım işlemi senkronize edildi.",
  "noNewReceiveTransaction": "Yeni alım işlemi bulunamadı.",
  "viewOnBscScan": "BscScan'de Görüntüle",
  "connectWalletFirst": "Önce cüzdan bağlayın.",
  "processing": "İşleniyor...",
  "loading": "Yükleniyor...",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın."
}